export const dashUrl = '/dash/';
export const dashSeoPerformaceUrl = '/dash/seo-performance/';
